var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosemedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.208 8.576a1.82 1.82 0 00-2.658 0 2.032 2.032 0 000 2.782l8.515 8.91-8.394 8.786a1.915 1.915 0 000 2.62 1.715 1.715 0 002.504 0l8.394-8.784 8.074 8.45a1.82 1.82 0 002.658 0 2.032 2.032 0 000-2.782l-8.074-8.45 8.195-8.577a1.915 1.915 0 000-2.62 1.715 1.715 0 00-2.505 0l-8.194 8.576-8.515-8.91z",
    fill: "#fff"
  })));
}
export default SvgClosemedium;